<template>
    <div>
        <el-dialog
            title="房源动态"
            :visible.sync="shwodialog"
            width="1000px"
            :before-close="back">
            <div class="base-warp">
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-form :model="form" ref="form" label-width="80px" :inline="false" size="mini">
                            <el-form-item label="选择阶段">
                                <el-select v-model="form.stage" placeholder="请选择" allow-create default-first-option>
                                    <el-option-group v-for="(stage, sindex) in stages"
                                        :key="sindex.stage"
                                        :label="stage.label">
                                        <el-option v-for="(item, index) in stage.options"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="日期">
                                <el-date-picker
                                    v-model="form.date"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="价格变化">
                                <el-input v-model="form.price" type="number" placeholder="请输入当前价格，没变动可不填"><i slot="suffix">万</i></el-input>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input v-model="form.remark"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="confirm">添加动态</el-button>
                                <el-button @click="back">取消</el-button>
                            </el-form-item>
                        </el-form>
                        
                    </el-col>
                    <el-col :span="8">
                        <div class="time-line-box">
                            <el-timeline :reverse="true">
                                <el-timeline-item v-for="item in dynamics"
                                    :key="item._id['$oid']"
                                    :timestamp="item.addDate"
                                    placement="top"
                                    type="primary"
                                    size="normal"> 
                                    <p class="text">日期：{{item.date}}</p>
                                    <p class="text">拍卖阶段：{{item.stage}}</p>
                                    <p class="text">当前价格：{{item.price}}</p>
                                    <p class="text">备注：{{item.remark}}</p>
                                </el-timeline-item>
                            </el-timeline>
                            
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            shwodialog: true,
            form: {
                stage: '',
                date: '',
                price: '',
                remark: '',
            },
            house: '',
            id: '',
            dynamics: [],
            stages: [
                {label:'拍卖状态', options: [{value: '即将开拍'},{value: '正在进行'},{value: '已结束'},{value: '中止'},{value: '撤拍'},{value: '成交'},{value: '流拍'},{value: '暂缓'},]},
                {label:'拍卖阶段', options: [{value: '一拍'},{value: '二拍'},{value: '变卖'},{value: '其他'}]},
            ],
        }
    },
    mounted () {
        this.form.date = new Date();
        this.id = this.$route.query.id;
        this.gethouseinfo();
        this.getdynamic();
    },
    methods: {
        getdynamic() {
            var params = {
                id: this.id
            }
            this.$api.getforeclosuredynamic(params)
                .then(data=>{
                    this.dynamics = data;
                })
        },
        gethouseinfo() {
            var params = {
                id: this.id
            }
            this.$api.getforeclosurevsid(params)
                .then(data=>{
                    let {house} = data;
                    this.house = house;
                    this.form.stage = house.stage;
                })
        },
        confirm() {
            var params = {
                id: this.id,
                stage: this.form.stage,
                date: this.form.date,
                price: this.form.price,
                remark: this.form.remark,
            }
            this.$api.addforeclosuredynamic(params)
                .then(data=>{
                    this.$message.success(data);
                    this.form = {
                        stage: '',
                        price: '',
                        remark: '',
                    }
                })
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>